<template>
  <Teleport :to="modalRoot">
     <bs-modal
       ref="bsModal"
       :name="`initial-proposal-${issueid}`"
       :ok-title="$t('javascript.set_my_visible')"
       :cancel-title="$t('javascript.cancel')"
       @ok="emitOk"
       @cancel="emitCancel"

       :disable-ok="true"
       :disable-cancel="true"
       :value="value"
       :model-value="value"
       @update:model-value="emitInput"
     >
       <form class="form-inline">
         <div class="row">
           <div class="col-sm-3">
             <button type="button" class="btn btn-secondary" @click="handleCancelClick">
               {{ $t('javascript.cancel') }}
             </button>
           </div> 
           <div class="col-sm-6">
             <button type="button" class="btn btn-primary" @click="handleOkClick">
               {{ $t('javascript.set_my_visible') }}
             </button>
           </div>
           <div class="col-sm-1" style="margin-top:10px;">
             <span v-html="$t('javascript.to')"></span> &nbsp;
           </div> 
           <div class="col-sm-2">
             <div class="form-group">
               <select
                 :value="proposal"
                 @input="emitProposalUpdate"
                 class="form-control form-inline"
               >
                 <option v-for="point in gridPoints" :key="point">
                   {{ point }}
                 </option>
               </select>
             </div>
           </div>
         </div>
       </form>
     </bs-modal>
   </Teleport>
  </template>

<script>
import { ref, onMounted, inject, getCurrentInstance } from 'vue'
import BsModal from './bs_modal.vue'

export default {
  name: "InitialProposal",
  props: {
    proposal: Number,
    value: Boolean,
    gridPoints: Array,
    issueid: Number,
  },
  components: {
    BsModal,
  },
  emits: ['ok', 'cancel', 'update:proposal', 'update:modelValue'],
  setup(props, { emit }) {
    const bsModal = ref(null)
    const modalRoot = inject('modalRoot')
    const getProposal = (event) => {
      return parseFloat(event.target.value)
    }

    const emitOk = () => {
      emit('ok')
    }

    const emitCancel = () => {
      emit('cancel')
    }

    const emitInput = (val) => {
      emit('update:modelValue', val)
    }

    const emitProposalUpdate = (event) => {
      emit('update:proposal', getProposal(event))
    }

    const handleOkClick = () => {
      emitOk()
      bsModal.value.modalHide()
    }

    const handleCancelClick = () => {
      emitCancel()
      bsModal.value.modalHide()
    }

    onMounted(() => {
     const instance = getCurrentInstance()
     const el = instance?.vnode.el

     if (!el) return

     const root = el.getRootNode()
     console.log(root)
     console.log("ASDASDASDASDASDA")
    });

    return {
      bsModal,
      modalRoot,
      getProposal,
      handleOkClick,
      handleCancelClick,
      emitProposalUpdate,
      emitOk,
      emitCancel,
      emitInput
    }
  }

}
</script>
